
import customModal from "@/service/customModal.js";
import editPassword from "./editPassword.vue";
/**
 * @description: 用户详情
 * @param {*} item
 * @return {*}
 */
export const resetPassword = ({ config = {} }) => {
  return customModal(editPassword, { config });
};
